// Baloon
const baloonTrigger = document.querySelectorAll('.baloon-trigger');

// つけるクラス名
const toggleClassName = 'baloon-active';

// 除外するクラス
const exceptClassName = 'js-room-disabled';

if( baloonTrigger ){
  for( const elm of baloonTrigger ){
    elm.addEventListener('mouseenter', (e) => {
      e.preventDefault();
      baloonAddClass(e.target);
    });

    elm.addEventListener('mouseleave', (e) => {
      e.preventDefault();
      baloonRemoveClass(e.target);
    });

  }
}



// クラスをつける
function baloonAddClass($elm){
  // ✕ 以外にクラスをつける
  if( !$elm.classList.contains(exceptClassName) && !$elm.classList.contains(toggleClassName) ){
    $elm.parentNode.classList.add(toggleClassName);
  }
  return;
}

// クラスをはずす
function baloonRemoveClass($elm){
  // ✕ 以外のクラスをはずす
  if( !$elm.classList.contains(exceptClassName) && !$elm.classList.contains(toggleClassName) ){
    $elm.parentNode.classList.remove(toggleClassName);
  }
  return;
}
